import { useEffect, useState } from 'react';
import { apiClient } from '../../lib/apiClient.js';

interface UserRow {
  id: string;
  email: string | null;
  handle: string;
  role: string;
  displayName: string;
  status: string;
  createdAt: string;
}

export function UsersModule(): JSX.Element {
  const [users, setUsers] = useState<UserRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [error, setError] = useState<string | null>(null);

  const load = () => {
    setLoading(true);
    return apiClient.get<{ users: UserRow[] }>('/api/v1/users').then((res) => setUsers(res.data.users ?? [])).catch((err) => setError((err as { message?: string })?.message ?? 'Could not load users.')).finally(() => setLoading(false));
  };

  useEffect(() => { void load(); }, []);

  const filtered = users.filter((user) => `${user.displayName} ${user.handle} ${user.email ?? ''}`.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="users-module">
      <div className="header"><h2>Users</h2><button type="button" className="btn btn-primary">Invite user</button></div>
      <input className="search-input" placeholder="Search users" value={query} onChange={(e) => setQuery(e.target.value)} />
      {loading && <div className="loading">Loading users…</div>}
      {error && <div className="error">{error}</div>}
      {!loading && !error && <div className="manager-grid">{filtered.map((user) => <div className="manager-card" key={user.id}>
        <h3>{user.displayName}</h3><p className="muted">@{user.handle} · {user.email ?? 'No email'}</p><p className="status-badge">{user.status}</p><p>Role: {user.role}</p><div className="actions"><button type="button" className="btn btn-secondary">View activity</button><button type="button" className="btn btn-warning">Change role</button></div>
      </div>)}</div>}
      {!loading && !error && filtered.length === 0 && <div className="empty-state">No matching users.</div>}
    </div>
  );
}